import { defineMessages } from "react-intl";

const messages = defineMessages({
    name: {
        description: "Trial heading when product display name is not provided",
        defaultMessage: "Start your free {br}{trialPeriod}-day trial"
    },
    nameWithProduct: {
        description: "Trial heading with product display name",
        defaultMessage: "Start your free {br}{trialPeriod}-day {productDisplayName} trial"
    }
});

export default messages;
